import { Component, OnInit } from '@angular/core';
import { SurveyTypes } from '../models/surveytypes';
import { VisionService } from '../services/vision.service';

@Component({
    selector: 'app-jobs-visions',
    templateUrl: './jobs-visions.component.html',
    styleUrls: ['./jobs-visions.component.scss']
})

export class JobsVisionsComponent implements OnInit {
    user: any;
    email: string;
    user_id: string;
    vision_title: string;
    vision_typeId: number;
    user_data: any;
    vision_selected1: number; vision_selected2: number; vision_selected3: number; vision_selected4: number;

    constructor(private visionService: VisionService, private surveyTypes: SurveyTypes) {
        this.user = JSON.parse(localStorage.getItem('user_data'));
        this.email = this.user.email;
        this.user_id = this.user.id;
        this.vision_title = localStorage.getItem('vision_title');
        this.vision_typeId = this.surveyTypes.getTitleId(this.vision_title);  // selected text

        this.visionService.getUserVisionsCriterias(this.email).subscribe(result => {
            this.user_data = result.User;
            if (this.user_data.surveys) {
                const isExist = this.user_data.surveys.filter(x => x.title === this.vision_title)[0];
                if (isExist) {

                } else {
                    // this.addNewVision();
                }
            }
        });
    }

    ngOnInit() { }

    onTemplateChange(radioValue: any) {
        this.vision_typeId = radioValue;
        this.vision_title = this.surveyTypes.getTitle(radioValue);
    }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/jobs/jobs-visions.component.ts